/**
 * ThemeStage — full-screen background gradient + theme background art.
 * Character art is rendered separately in ChatRoute only.
 */

import { useEffect, useState } from 'react';
import type { ReactElement } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { useThemeStore } from '../../state';

import styles from './ThemeStage.module.css';

export function ThemeStage(): ReactElement {
  const theme = useThemeStore((s) => s.current);
  const [bgUrl, setBgUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void theme.assets.backgroundArt().then((mod) => {
      if (!cancelled) setBgUrl(mod.default);
    });
    return () => {
      cancelled = true;
    };
  }, [theme.id, theme.assets]);

  const fadeSec = theme.animation.crossfadeMs / 1000;

  return (
    <div className={styles.stage} aria-hidden="true" data-testid="theme-stage">
      <AnimatePresence mode="wait">
        {bgUrl !== null ? (
          <motion.div
            key={theme.id}
            className={styles.background}
            style={{ backgroundImage: `url(${bgUrl})` }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: fadeSec }}
            data-theme-id={theme.id}
          />
        ) : null}
      </AnimatePresence>
    </div>
  );
}
